/* Kanser türü sayfaları (/kanser/:id) — her tanı için SEO odaklı rehber içeriği.
   Editoryal kurallar: kesin şifa vaadi YOK, bağlamsız yüzde YOK, standart tedavi küçümsenmez,
   uygunluk her zaman merkezin hekim değerlendirmesine bağlıdır. TR/EN. */

export const TUMOR_PAGES = {
  brain: {
    tr: {
      title: "Beyin Tümörleri",
      intro: "Beyin tümörlerinde tedavi; tümörün tipi, derecesi, konumu ve daha önce alınan tedavilere göre planlanır. Japonya; proton tedavisi, BNCT ve kişiye özel aşı (AFTV) gibi ileri seçeneklerin değerlendirilebildiği merkezlere sahiptir.",
      bullets: [
        "Glioblastom (GBM) gibi agresif tiplerde kişiye özel aşı programları, standart tedaviye ek olarak araştırma/protokol kapsamında değerlendirilebilir.",
        "Proton tedavisi, kritik yapılara yakın tümörlerde çevre dokuyu korumayı hedefleyen bir ışın hassasiyeti sunar.",
        "BNCT, tekrarlayan baş-boyun ve bazı beyin tümörlerinde Japon merkezlerinde uygulanan hedefli bir yöntemdir; uygunluk bor dağılımı ve doz planına bağlıdır.",
      ],
      note: "Beyin tümörlerinde hiçbir yöntem tek başına 'kesin çözüm' değildir; dosyanızın hangi seçeneklere uygun olduğu ancak uzman kurul değerlendirmesiyle netleşir.",
    },
    en: {
      title: "Brain Tumors",
      intro: "Treatment of brain tumors is planned according to tumor type, grade, location and prior therapies. Japan hosts centers where advanced options such as proton therapy, BNCT and personalized vaccines (AFTV) can be evaluated.",
      bullets: [
        "For aggressive types like glioblastoma (GBM), personalized vaccine programs may be considered in addition to standard care, within protocols.",
        "Proton therapy offers beam precision aimed at sparing critical structures near the tumor.",
        "BNCT is a targeted method used in Japanese centers for recurrent head & neck and selected brain tumors; eligibility depends on boron distribution and dose planning.",
      ],
      note: "No single method is a 'definitive cure' for brain tumors; which options fit your case only becomes clear through expert board evaluation.",
    },
  },
  headneck: {
    tr: {
      title: "Baş & Boyun Kanserleri",
      intro: "Baş-boyun kanserleri Japonya'daki ileri teknolojilerin en güçlü olduğu alanlardan biridir: BNCT bu hasta grubunda Japonya'da rutin klinik kullanıma giren ilk uygulamalardandır, foto-immünoterapi de yine bu bölge için onaylanmıştır.",
      bullets: [
        "Tekrarlayan veya cerrahiye uygun olmayan olgularda BNCT, çoğunlukla tek seanslık hedefli bir seçenek olarak değerlendirilebilir.",
        "Foto-immünoterapi (ışıkla etkinleşen hedefli tedavi) baş-boyun bölgesinde Japonya'da ruhsatlı bir yöntemdir.",
        "Proton ve ağır iyon, çevredeki kritik organları korumayı hedefleyen ışın hassasiyeti sağlar.",
      ],
      note: "Seçicilik ve sonuçlar; tümörün yeri, evresi ve önceki tedavilere göre değişir — kesin ifadeler yerine dosyanıza özel değerlendirme esastır.",
    },
    en: {
      title: "Head & Neck Cancers",
      intro: "Head & neck cancers are among the strongest areas of Japan's advanced technologies: BNCT entered routine clinical use for this group in Japan, and photo-immunotherapy is also approved for this region.",
      bullets: [
        "For recurrent or inoperable cases, BNCT may be considered as a targeted, often single-session option.",
        "Photo-immunotherapy (light-activated targeted treatment) is a licensed method in Japan for the head & neck region.",
        "Proton and heavy ion therapies provide beam precision aimed at protecting surrounding critical organs.",
      ],
      note: "Selectivity and outcomes vary by tumor location, stage and prior treatments — case-specific evaluation replaces blanket statements.",
    },
  },
  pancreas: {
    tr: {
      title: "Pankreas Kanseri",
      intro: "Pankreas kanseri, tedavisi en zor türlerden biridir ve gerçekçi konuşmayı hak eder. Japonya'da ağır iyon tedavisi lokal kontrolü hedefleyen bir seçenek olarak, kesisiz kateter tedavileri (IGT) ise ileri evrede destekleyici yaklaşımlar olarak değerlendirilir.",
      bullets: [
        "Lokal ileri, cerrahiye uygun olmayan olgularda ağır iyon tedavisi Japon merkezlerinde uygulanan bir yöntemdir.",
        "Kateter yoluyla bölgesel tedaviler ve hipertermi, kesi olmadan uygulanan destekleyici seçeneklerdir.",
        "Kişiye özel aşı (AFTV), uygun olgularda standart tedaviye ek olarak değerlendirilebilir.",
      ],
      note: "Pankreas kanserinde hiçbir yöntem için genel bir 'başarı yüzdesi' verilemez; evre, genel durum ve önceki tedaviler sonucu belirler.",
    },
    en: {
      title: "Pancreatic Cancer",
      intro: "Pancreatic cancer is among the hardest to treat and deserves honest conversation. In Japan, heavy ion therapy is evaluated as a local-control option, and incision-free catheter therapies (IGT) as supportive approaches in advanced disease.",
      bullets: [
        "For locally advanced, inoperable cases, heavy ion therapy is practiced at Japanese centers.",
        "Regional catheter-based therapies and hyperthermia are incision-free supportive options.",
        "Personalized vaccine (AFTV) may be considered in addition to standard care in suitable cases.",
      ],
      note: "No general 'success rate' can be quoted for pancreatic cancer; stage, performance status and prior treatments determine outcomes.",
    },
  },
  prostate: {
    tr: {
      title: "Prostat Kanseri",
      intro: "Prostat kanseri, parçacık tedavilerinin (proton ve ağır iyon) dünyada en olgun kanıt birikimine sahip olduğu alanlardandır. Japonya'daki QST gibi merkezler bu konuda on yıllara uzanan deneyime sahiptir.",
      bullets: [
        "Ağır iyon ve proton tedavileri, rektum ve idrar yollarını korumayı hedefleyen hassasiyetiyle cerrahiye alternatif olarak değerlendirilir.",
        "Tedavi genellikle birkaç haftalık kısa kurslar halinde planlanır.",
        "Yayınlanan hasta serileri uzun dönem lokal kontrol sonuçları bildirmektedir; sizin için geçerli olanı evre ve risk grubunuz belirler.",
      ],
      note: "Erken evrede aktif izlem dahil tüm seçenekler konuşulmalıdır; karar üroloji ve radyasyon onkolojisi kurulunundur.",
    },
    en: {
      title: "Prostate Cancer",
      intro: "Prostate cancer is one of the areas where particle therapies (proton and heavy ion) have the most mature evidence worldwide. Japanese centers such as QST hold decades of experience.",
      bullets: [
        "Heavy ion and proton therapies are evaluated as alternatives to surgery, with precision aimed at protecting the rectum and urinary tract.",
        "Treatment is usually planned as short courses over a few weeks.",
        "Published patient series report long-term local control; what applies to you is determined by your stage and risk group.",
      ],
      note: "All options including active surveillance in early stages should be discussed; the decision belongs to the urology and radiation oncology board.",
    },
  },
  lung: {
    tr: {
      title: "Akciğer Kanseri",
      intro: "Akciğer kanserinde erken evrede cerrahi standarttır; cerrahiye uygun olmayan veya kalp-akciğer rezervi sınırlı hastalarda proton ve ağır iyon gibi hassas ışın yöntemleri Japonya'da güçlü seçeneklerdir.",
      bullets: [
        "Proton tedavisi, tümör çevresindeki sağlıklı akciğer dokusunu korumayı hedefler.",
        "İleri evrede immünoterapi ve hedefe yönelik tedavilerle birlikte multimodal planlama yapılır.",
        "Kateter bazlı bölgesel yaklaşımlar (IGT), seçilmiş ileri evre olgularda destekleyici olarak gündeme gelebilir.",
      ],
      note: "Evre ve moleküler profil (ör. sürücü mutasyonlar) tedavi haritasını değiştirir; dosyanız bu bilgilerle değerlendirilir.",
    },
    en: {
      title: "Lung Cancer",
      intro: "In lung cancer, surgery is standard in early stages; for patients unfit for surgery or with limited cardiopulmonary reserve, precise beam methods such as proton and heavy ion therapy are strong options in Japan.",
      bullets: [
        "Proton therapy aims to protect healthy lung tissue around the tumor.",
        "In advanced disease, multimodal planning combines immunotherapy and targeted agents.",
        "Catheter-based regional approaches (IGT) may be considered as supportive options in selected advanced cases.",
      ],
      note: "Stage and molecular profile (e.g. driver mutations) reshape the treatment map; your file is evaluated with these details.",
    },
  },
  liver: {
    tr: {
      title: "Karaciğer Tümörleri",
      intro: "Karaciğer tümörlerinde (hepatoselüler karsinom ve metastazlar) cerrahi ve ablasyon standarttır; bu seçeneklerin uygun olmadığı durumlarda ağır iyon ve kateter bazlı bölgesel tedaviler Japonya'da değerlendirilen ileri seçeneklerdir.",
      bullets: [
        "Ağır iyon tedavisi, karaciğer fonksiyonunu korumayı hedefleyen hassas bir ışın yöntemidir.",
        "Kateter yoluyla damar içi bölgesel tedaviler (IGT), kesi olmadan uygulanır.",
        "Kişiye özel aşı (AFTV), uygun olgularda destekleyici protokol olarak konuşulabilir.",
      ],
      note: "Karaciğer rezervi (Child-Pugh gibi) tedavi seçimini doğrudan etkiler; karar hepatoloji ve onkoloji kurulunundur.",
    },
    en: {
      title: "Liver Tumors",
      intro: "For liver tumors (hepatocellular carcinoma and metastases), surgery and ablation are standard; when these are unsuitable, heavy ion and catheter-based regional therapies are among the advanced options evaluated in Japan.",
      bullets: [
        "Heavy ion therapy is a precise beam method aimed at preserving liver function.",
        "Intra-arterial regional catheter therapies (IGT) are applied without incision.",
        "Personalized vaccine (AFTV) can be discussed as a supportive protocol in suitable cases.",
      ],
      note: "Liver reserve (e.g. Child-Pugh) directly affects treatment selection; the decision belongs to the hepatology and oncology board.",
    },
  },
  breast: {
    tr: {
      title: "Meme Kanseri",
      intro: "Meme kanserinde cerrahi, radyoterapi ve sistemik tedaviler güçlü standartlardır. Japonya'da foto-immünoterapi ve kişiye özel aşı gibi yeni yaklaşımlar, standart tedavilerin yerine değil, uygun olgularda yanına değerlendirilir.",
      bullets: [
        "Foto-immünoterapi, hedefli bir molekülün ışıkla etkinleştirilmesine dayanan yeni bir yaklaşımdır.",
        "Kişiye özel aşı (AFTV), nüks riskini azaltmayı hedefleyen destekleyici bir protokol olarak değerlendirilebilir.",
        "İmmünoterapi seçenekleri moleküler alt tipe göre planlanır.",
      ],
      note: "Alt tip (hormon reseptörü, HER2, üçlü negatif) tedavi haritasını belirler; dosyanız bu ayrıntılarla incelenir.",
    },
    en: {
      title: "Breast Cancer",
      intro: "In breast cancer, surgery, radiotherapy and systemic therapies are strong standards. Newer approaches in Japan such as photo-immunotherapy and personalized vaccines are evaluated alongside — not instead of — standard care in suitable cases.",
      bullets: [
        "Photo-immunotherapy is a novel approach based on light-activated targeted molecules.",
        "Personalized vaccine (AFTV) may be evaluated as a supportive protocol aiming to reduce recurrence risk.",
        "Immunotherapy options are planned according to molecular subtype.",
      ],
      note: "Subtype (hormone receptor, HER2, triple-negative) determines the treatment map; your file is reviewed with these details.",
    },
  },
  colorectal: {
    tr: {
      title: "Kolon & Rektum Kanseri",
      intro: "Kolorektal kanserde erken evrede cerrahi ile yüksek başarı şansı vardır; ileri evrede ise karaciğer metastazlarına yönelik bölgesel ve parçacık tedavileri Japonya'nın güçlü olduğu alanlardır.",
      bullets: [
        "Karaciğer metastazlarında ağır iyon ve kateter bazlı bölgesel tedaviler değerlendirilebilir.",
        "Cerrahi, Japon merkezlerinde minimal invaziv tekniklerle planlanır.",
        "Kişiye özel aşı (AFTV), uygun olgularda standart tedaviye ek protokol olarak konuşulabilir.",
      ],
      note: "Metastaz sayısı, yeri ve önceki tedaviler seçenekleri belirler; hiçbir yöntem her hasta için aynı sonucu vaat etmez.",
    },
    en: {
      title: "Colorectal Cancer",
      intro: "In colorectal cancer, early-stage surgery carries high success; in advanced disease, regional and particle therapies targeting liver metastases are among Japan's strengths.",
      bullets: [
        "For liver metastases, heavy ion and catheter-based regional therapies may be evaluated.",
        "Surgery is planned with minimally invasive techniques at Japanese centers.",
        "Personalized vaccine (AFTV) can be discussed as an adjunct protocol in suitable cases.",
      ],
      note: "The number and location of metastases and prior treatments determine the options; no method promises the same outcome for every patient.",
    },
  },
  leukemia: {
    tr: {
      title: "Lösemi",
      intro: "Lösemide kemoterapi ve kök hücre nakli standarttır; dirençli/tekrarlayan olgularda CAR-T hücre tedavisi Japonya'da ruhsatlı bir seçenektir, yeni nesil PiggyBac CAR-T ve iPSC kaynaklı hücreler ise araştırma programlarında ilerlemektedir.",
      bullets: [
        "CAR-T, belirli kan kanserlerinde bağışıklık hücrelerinin yeniden programlanmasına dayanan ruhsatlı bir tedavidir.",
        "PiggyBac teknolojisi, hücre üretimini sadeleştirmeyi hedefleyen araştırma aşamasındaki bir yaklaşımdır.",
        "iPSC kaynaklı hücre tedavileri Kyoto CiRA öncülüğünde geliştirilmektedir.",
      ],
      note: "Hücre tedavileri ciddi yan etki takibi gerektiren, yalnızca yetkin merkezlerde uygulanan tedavilerdir; uygunluk hematoloji kurulu kararıdır.",
    },
    en: {
      title: "Leukemia",
      intro: "In leukemia, chemotherapy and stem cell transplantation are standard; for refractory/relapsed cases, CAR-T cell therapy is a licensed option in Japan, while next-generation PiggyBac CAR-T and iPSC-derived cells advance through research programs.",
      bullets: [
        "CAR-T is a licensed therapy based on reprogramming immune cells in certain blood cancers.",
        "PiggyBac technology is an investigational approach aiming to simplify cell manufacturing.",
        "iPSC-derived cell therapies are being developed under Kyoto CiRA's leadership.",
      ],
      note: "Cell therapies require serious side-effect monitoring and are applied only at qualified centers; eligibility is the hematology board's decision.",
    },
  },
  lymphoma: {
    tr: {
      title: "Lenfoma",
      intro: "Lenfomada kemoterapi ve immünoterapi güçlü standartlardır; dirençli/tekrarlayan B-hücre lenfomalarda CAR-T hücre tedavisi Japonya'da ruhsatlı ve yerleşik bir seçenektir.",
      bullets: [
        "CAR-T, tekrarlayan B-hücre lenfomada etkinliği gösterilmiş bir hücre tedavisidir.",
        "iPSC kaynaklı 'stoktan hazır' hücre programları (iCART), bekleme süresini azaltmayı hedefleyen araştırma yaklaşımıdır.",
        "Değerlendirme, lenfomanın alt tipi ve önceki tedavi yanıtlarıyla yapılır.",
      ],
      note: "Lenfoma alt tipleri çok farklı seyreder; dosyanız hematoloji uzman kurulunca incelenir.",
    },
    en: {
      title: "Lymphoma",
      intro: "In lymphoma, chemotherapy and immunotherapy are strong standards; for refractory/relapsed B-cell lymphomas, CAR-T cell therapy is a licensed and established option in Japan.",
      bullets: [
        "CAR-T is a cell therapy with demonstrated efficacy in relapsed B-cell lymphoma.",
        "iPSC-derived 'off-the-shelf' cell programs (iCART) are an investigational approach aiming to shorten waiting time.",
        "Evaluation is based on lymphoma subtype and prior treatment responses.",
      ],
      note: "Lymphoma subtypes behave very differently; your file is reviewed by the hematology expert board.",
    },
  },
  esophagus: {
    tr: {
      title: "Özefagus (Yemek Borusu) Kanseri",
      intro: "Özefagus kanserinde cerrahi ve kemoradyoterapi standarttır. Japonya'da proton tedavisi kalp ve akciğeri korumayı hedefleyen hassasiyetiyle, foto-immünoterapi ise yeni bir seçenek olarak değerlendirilebilir.",
      bullets: [
        "Proton tedavisi, göğüs boşluğundaki kritik organları korumayı hedefler.",
        "Foto-immünoterapi, ışıkla etkinleşen hedefli bir yaklaşım olarak uygun olgularda konuşulabilir.",
        "Minimal invaziv cerrahi teknikleri Japon merkezlerinde yaygındır.",
      ],
      note: "Evre ve genel durum (beslenme, performans) tedavi planını belirler; karar multidisipliner kurulundur.",
    },
    en: {
      title: "Esophageal Cancer",
      intro: "In esophageal cancer, surgery and chemoradiotherapy are standard. In Japan, proton therapy may be evaluated for its precision in protecting the heart and lungs, and photo-immunotherapy as a newer option.",
      bullets: [
        "Proton therapy aims to protect critical organs within the chest cavity.",
        "Photo-immunotherapy may be discussed as a light-activated targeted approach in suitable cases.",
        "Minimally invasive surgical techniques are widespread at Japanese centers.",
      ],
      note: "Stage and performance status (nutrition, fitness) determine the treatment plan; the decision belongs to the multidisciplinary board.",
    },
  },
  bone: {
    tr: {
      title: "Kemik & Yumuşak Doku Tümörleri",
      intro: "Kemik ve yumuşak doku tümörlerinde (sarkomlar) cerrahi esastır; cerrahi sınırın zor olduğu bölgelerde ağır iyon tedavisi Japonya'da köklü deneyime sahip bir seçenektir.",
      bullets: [
        "Ağır iyon, omurga ve pelvis gibi zor lokalizasyonlarda lokal kontrolü hedefleyen bir yöntemdir.",
        "Proton tedavisi çevre dokuyu korumayı amaçlayan hassasiyet sunar.",
        "Kişiye özel aşı (AFTV) uygun olgularda destekleyici protokol olarak değerlendirilebilir.",
      ],
      note: "Sarkomlar nadir ve çok çeşitlidir; histolojik alt tip olmadan tedavi konuşulmaz.",
    },
    en: {
      title: "Bone & Soft Tissue Tumors",
      intro: "In bone and soft tissue tumors (sarcomas), surgery is the cornerstone; where surgical margins are difficult, heavy ion therapy is an option with long-standing experience in Japan.",
      bullets: [
        "Heavy ion therapy aims at local control in challenging locations such as spine and pelvis.",
        "Proton therapy offers precision that aims to spare surrounding tissue.",
        "Personalized vaccine (AFTV) may be evaluated as a supportive protocol in suitable cases.",
      ],
      note: "Sarcomas are rare and highly diverse; no treatment is discussed without the histological subtype.",
    },
  },
  pediatric: {
    tr: {
      title: "Çocukluk Çağı Tümörleri",
      intro: "Çocukluk çağı tümörlerinde ışın tedavisinin uzun vadeli etkileri özellikle önemlidir; proton tedavisi, gelişmekte olan dokuları korumayı hedeflediği için çocuklarda öne çıkan bir yöntemdir ve Japonya bu alanda güçlü merkezlere sahiptir.",
      bullets: [
        "Proton tedavisi, büyüme plakları ve gelişmekte olan organları korumayı hedefler.",
        "Tedavi planı çocuk onkolojisi, radyasyon onkolojisi ve aile ile birlikte yapılır.",
        "Anestezi destekli günlük uygulamalar çocuğun konforu için planlanır.",
      ],
      note: "Çocuklarda her karar pediatrik onkoloji kurulununundur; aileye süreç adım adım ve Türkçe anlatılır.",
    },
    en: {
      title: "Pediatric Tumors",
      intro: "In childhood tumors, the long-term effects of radiation matter greatly; proton therapy stands out in children as it aims to protect developing tissues, and Japan hosts strong centers in this field.",
      bullets: [
        "Proton therapy aims to protect growth plates and developing organs.",
        "Treatment planning is done together with pediatric oncology, radiation oncology and the family.",
        "Daily sessions with anesthesia support are planned for the child's comfort.",
      ],
      note: "Every decision in children belongs to the pediatric oncology board; the family is guided step by step, in Turkish.",
    },
  },
  skin: {
    tr: {
      title: "Cilt Kanseri & Melanom",
      intro: "Melanom ve cilt kanserlerinde cerrahi ve immünoterapi standarttır. Japonya'da foto-immünoterapi ve destekleyici immünoterapi protokolleri uygun olgularda değerlendirilebilir.",
      bullets: [
        "Foto-immünoterapi yüzeyel tümörlerde uygulanabilirliği araştırılan bir yöntemdir.",
        "İleri evre melanomda immünoterapi kombinasyonları merkezlerce planlanır.",
        "Kişiye özel aşı (AFTV) destekleyici protokol olarak konuşulabilir.",
      ],
      note: "BRAF gibi moleküler testler tedavi haritasını değiştirir; dosyanız bu sonuçlarla değerlendirilir.",
    },
    en: {
      title: "Skin Cancer & Melanoma",
      intro: "In melanoma and skin cancers, surgery and immunotherapy are standard. In Japan, photo-immunotherapy and supportive immunotherapy protocols may be evaluated in suitable cases.",
      bullets: [
        "Photo-immunotherapy is being explored for superficial tumors.",
        "In advanced melanoma, immunotherapy combinations are planned by the centers.",
        "Personalized vaccine (AFTV) can be discussed as a supportive protocol.",
      ],
      note: "Molecular tests such as BRAF reshape the treatment map; your file is evaluated with these results.",
    },
  },
  stomach: {
    tr: {
      title: "Mide Kanseri",
      intro: "Mide kanserinde Japonya dünyanın en deneyimli ülkelerinden biridir — erken evrede endoskopik tedaviler ve D2 diseksiyonlu cerrahi Japon cerrahisinin referans alanlarıdır.",
      bullets: [
        "Erken evrede endoskopik rezeksiyon (ESD) gibi organ koruyucu teknikler uygulanır.",
        "İleri evrede immünoterapi ve hedefe yönelik tedavilerle multimodal planlama yapılır.",
        "Kişiye özel aşı (AFTV) uygun olgularda destekleyici protokol olarak değerlendirilebilir.",
      ],
      note: "Evre ve yayılım tedavi sırasını belirler; karar gastroenteroloji ve onkoloji kurulunundur.",
    },
    en: {
      title: "Stomach (Gastric) Cancer",
      intro: "Japan is one of the world's most experienced countries in gastric cancer — endoscopic treatments in early stages and D2-dissection surgery are reference fields of Japanese surgery.",
      bullets: [
        "Organ-preserving techniques such as endoscopic resection (ESD) are applied in early stages.",
        "In advanced disease, multimodal planning combines immunotherapy and targeted agents.",
        "Personalized vaccine (AFTV) may be evaluated as a supportive protocol in suitable cases.",
      ],
      note: "Stage and spread determine the treatment sequence; the decision belongs to the gastroenterology and oncology board.",
    },
  },
  gyn: {
    tr: {
      title: "Jinekolojik Kanserler",
      intro: "Rahim, yumurtalık ve rahim ağzı kanserlerinde cerrahi ve kemoradyoterapi standarttır; tekrarlayan olgularda ağır iyon ve foto-immünoterapi Japonya'da değerlendirilen ileri seçeneklerdir.",
      bullets: [
        "Ağır iyon tedavisi, pelviste cerrahisi zor tekrarlayan olgularda lokal kontrolü hedefler.",
        "Foto-immünoterapi uygun yüzeyel/bölgesel olgularda konuşulabilir.",
        "Cerrahi, minimal invaziv tekniklerle planlanır.",
      ],
      note: "Jinekolojik kanserlerde fertilite ve yaşam kalitesi konuları da tedavi planının parçasıdır; açıkça konuşulur.",
    },
    en: {
      title: "Gynecological Cancers",
      intro: "In uterine, ovarian and cervical cancers, surgery and chemoradiotherapy are standard; for recurrent cases, heavy ion therapy and photo-immunotherapy are advanced options evaluated in Japan.",
      bullets: [
        "Heavy ion therapy aims at local control in recurrent pelvic cases difficult to operate.",
        "Photo-immunotherapy may be discussed in suitable superficial/regional cases.",
        "Surgery is planned with minimally invasive techniques.",
      ],
      note: "Fertility and quality-of-life topics are part of the treatment plan in gynecological cancers; they are discussed openly.",
    },
  },
  recurrence: {
    tr: {
      title: "Nüks & Metastaz",
      intro: "Tekrarlayan veya metastatik hastalıkta amaç çoğunlukla hastalığı kontrol altında tutmak ve yaşam kalitesini korumaktır. Japonya'da parçacık tedavileri, kateter bazlı bölgesel tedaviler, immünoterapi ve kişiye özel aşı gibi seçenekler bu tabloda değerlendirilir.",
      bullets: [
        "Oligometastaz (sınırlı yayılım) durumunda ağır iyon/proton ile hedefli lokal tedavi konuşulabilir.",
        "Kateter bazlı bölgesel tedaviler (IGT) ve hipertermi kesisiz seçeneklerdir.",
        "Kişiye özel aşı (AFTV) ve immünoterapi, sistemik kontrolü desteklemeyi hedefleyen protokollerdir.",
      ],
      note: "Bu tabloda gerçekçi beklenti ve dürüst konuşma esastır; hiçbir yöntem 'son şans' diliyle sunulmaz.",
    },
    en: {
      title: "Recurrence & Metastasis",
      intro: "In recurrent or metastatic disease, the goal is usually disease control and quality of life. In Japan, particle therapies, catheter-based regional treatments, immunotherapy and personalized vaccines are evaluated in this setting.",
      bullets: [
        "In oligometastatic (limited spread) disease, targeted local treatment with heavy ion/proton may be discussed.",
        "Catheter-based regional therapies (IGT) and hyperthermia are incision-free options.",
        "Personalized vaccine (AFTV) and immunotherapy are protocols aiming to support systemic control.",
      ],
      note: "Realistic expectations and honest conversation are essential here; no method is presented as a 'last chance'.",
    },
  },
};
